module.exports = fox._r("components/iframe/images/promo-iframe-comix.jpg", __webpack_public_path__ + "components/iframe/images/promo-iframe-comix.jpg");


//////////////////
// WEBPACK FOOTER
// ./components/iframe/images/promo-iframe-comix.jpg
// module id = 21
// module chunks = 5